import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "landing-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.subtitle), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
      _createElementVNode("button", {
        class: "cta",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToBooking && _ctx.goToBooking(...args)))
      }, _toDisplayString(_ctx.cta), 1)
    ])
  ]))
}